import { LanguageEnum } from '../enums/language.enum';
import { Language } from '../interfaces/language.interface';

/**
 * holds all possible languages
 */
export const languages: Language[] = [
	{ title: 'language.de', value: LanguageEnum.de },
	{ title: 'language.en', value: LanguageEnum.en },
];
